import type { InputHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { cn } from './utils';

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
    error?: boolean;
};

const Input = forwardRef<HTMLInputElement, InputProps>(
    ({ className, error, type = 'text', ...props }, ref) => {
        return (
            <input
                ref={ref}
                type={type}
                className={cn('nx-input', error && 'nx-input--error', className)}
                aria-invalid={error || props['aria-invalid'] ? true : undefined}
                {...props}
            />
        );
    },
);

Input.displayName = 'Input';

export { Input };
export type { InputProps };
